import { gql } from '@apollo/client'

export const OrganizationHomePageFragment = gql`
  fragment OrganizationHomePageFragment on Organization {
    id
    slug
    city
    displayName
    timeZone
    shouldExposeInspectionAvailabilityInformationToPublic
    recordSettings {
      inspectionAvailabilityWindows {
        ...InspectionAvailabilityWindowDataFragment
      }
    }
    recordTypes {
      id
      displayName
      allowInspections
      recordSettings {
        inspectionCutoffTime
      }
    }
  }
`
